const canvas = document.getElementById('canvas');
const ctx = canvas.getContext('2d');

let W, H;
let points = [];
let basePoints = [];
let pointColors = [];
let mouse = { x: -9999, y: -9999 };
let smoothMouse = { x: -9999, y: -9999 };
let mouseActivity = 0;
const INFLUENCE_RADIUS = 400;
const POINT_DENSITY = 80;
const DISPLACEMENT_STRENGTH = 110;

const gradientStops = [
  [220, 60, 60],
  [230, 80, 100],
  [210, 70, 140],
  [170, 60, 180],
  [120, 60, 200],
  [70, 80, 210],
  [50, 100, 220],
];

function sampleGradient(t) {
  const stops = [0, 0.25, 0.40, 0.60, 0.85, 0.90, 1.0];
  t = Math.max(0, Math.min(1, t));
  for (let i = 0; i < stops.length - 1; i++) {
    if (t <= stops[i + 1]) {
      const frac = (t - stops[i]) / (stops[i + 1] - stops[i]);
      return lerpColor(gradientStops[i], gradientStops[i + 1], frac);
    }
  }
  return gradientStops[gradientStops.length - 1];
}

function lerpColor(c1, c2, t) {
  return [
    c1[0] + (c2[0] - c1[0]) * t,
    c1[1] + (c2[1] - c1[1]) * t,
    c1[2] + (c2[2] - c1[2]) * t,
  ];
}

// Size canvas to its parent container, not the window
function resize() {
  const parent = canvas.parentElement;
  const rect = parent.getBoundingClientRect();
  W = canvas.width = rect.width;
  H = canvas.height = rect.height;
  generatePoints();
}

function generatePoints() {
  basePoints = [];
  points = [];
  pointColors = [];

  const cols = Math.ceil(W / POINT_DENSITY) + 2;
  const rows = Math.ceil(H / POINT_DENSITY) + 2;

  for (let row = -2; row <= rows + 2; row++) {
    for (let col = -2; col <= cols + 2; col++) {
      const jitterX = (Math.random() - 0.5) * POINT_DENSITY * 0.9;
      const jitterY = (Math.random() - 0.5) * POINT_DENSITY * 0.9;
      const x = col * POINT_DENSITY + jitterX;
      const y = row * POINT_DENSITY + jitterY;
      basePoints.push({ x, y });
      points.push({ x, y });

      const t = x / W;
      const jitterT = Math.max(0, Math.min(1, t + (Math.random() - 0.5) * 0.06));
      const c = sampleGradient(jitterT);
      const brightness = 0.85 + Math.random() * 0.3;
      pointColors.push([
        Math.min(255, c[0] * brightness) | 0,
        Math.min(255, c[1] * brightness) | 0,
        Math.min(255, c[2] * brightness) | 0,
        0.65 + Math.random() * 0.25
      ]);
    }
  }
}

function triangulate(pts) {
  const superTriangle = [
    { x: -W * 2, y: -H * 2 },
    { x: W * 3, y: -H * 2 },
    { x: W / 2, y: H * 4 }
  ];

  let triangles = [superTriangle];

  for (const p of pts) {
    let badTriangles = [];
    for (const tri of triangles) {
      if (inCircumcircle(p, tri)) {
        badTriangles.push(tri);
      }
    }

    let polygon = [];
    for (const tri of badTriangles) {
      for (let i = 0; i < 3; i++) {
        const edge = [tri[i], tri[(i + 1) % 3]];
        let shared = false;
        for (const other of badTriangles) {
          if (other === tri) continue;
          for (let j = 0; j < 3; j++) {
            const oEdge = [other[j], other[(j + 1) % 3]];
            if ((edge[0] === oEdge[0] && edge[1] === oEdge[1]) ||
                (edge[0] === oEdge[1] && edge[1] === oEdge[0])) {
              shared = true;
              break;
            }
          }
          if (shared) break;
        }
        if (!shared) polygon.push(edge);
      }
    }

    triangles = triangles.filter(t => !badTriangles.includes(t));

    for (const edge of polygon) {
      triangles.push([edge[0], edge[1], p]);
    }
  }

  const sv = new Set(superTriangle);
  triangles = triangles.filter(tri =>
    !tri.some(v => sv.has(v))
  );

  return triangles;
}

function inCircumcircle(p, tri) {
  const [a, b, c] = tri;
  const ax = a.x - p.x, ay = a.y - p.y;
  const bx = b.x - p.x, by = b.y - p.y;
  const cx = c.x - p.x, cy = c.y - p.y;

  const det = (ax * ax + ay * ay) * (bx * cy - cx * by)
            - (bx * bx + by * by) * (ax * cy - cx * ay)
            + (cx * cx + cy * cy) * (ax * by - bx * ay);
  return det > 0;
}

let animFrame;
let time = 0;

function update() {
  mouseActivity *= 0.97;

  smoothMouse.x += (mouse.x - smoothMouse.x) * 0.08;
  smoothMouse.y += (mouse.y - smoothMouse.y) * 0.08;

  time += 0.006 * mouseActivity;

  for (let i = 0; i < points.length; i++) {
    const bp = basePoints[i];

    const drift = mouseActivity;
    const driftX = Math.sin(time + bp.x * 0.01 + bp.y * 0.007) * 3 * drift;
    const driftY = Math.cos(time * 0.8 + bp.y * 0.012 + bp.x * 0.005) * 3 * drift;

    let targetX = bp.x + driftX;
    let targetY = bp.y + driftY;

    const dx = bp.x - smoothMouse.x;
    const dy = bp.y - smoothMouse.y;
    const dist = Math.hypot(dx, dy);

    if (dist < INFLUENCE_RADIUS && dist > 0) {
      const falloff = Math.pow(1 - dist / INFLUENCE_RADIUS, 2) * mouseActivity;
      const seed1 = bp.x * 0.073 + bp.y * 0.117;
      const seed2 = bp.x * 0.131 - bp.y * 0.091;
      const angle = Math.sin(seed1) * Math.PI * 2 + time * 0.5;
      const magnitude = (Math.cos(seed2) * 0.5 + 0.5) * DISPLACEMENT_STRENGTH * falloff;
      targetX += Math.cos(angle) * magnitude;
      targetY += Math.sin(angle) * magnitude;
    }

    points[i].x += (targetX - points[i].x) * 0.12;
    points[i].y += (targetY - points[i].y) * 0.12;
  }
}

function draw() {
  ctx.clearRect(0, 0, W, H);

  const grad = ctx.createLinearGradient(0, 0, W, 0);
  grad.addColorStop(0,    'rgb(187, 51, 51)');
  grad.addColorStop(0.25, 'rgb(196, 68, 85)');
  grad.addColorStop(0.40, 'rgb(179, 60, 119)');
  grad.addColorStop(0.60, 'rgb(145, 51, 153)');
  grad.addColorStop(0.85, 'rgb(102, 51, 170)');
  grad.addColorStop(0.90, 'rgb(60, 68, 179)');
  grad.addColorStop(1,    'rgb(43, 85, 187)');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  const pointIndex = new Map();
  for (let i = 0; i < points.length; i++) {
    pointIndex.set(points[i], i);
  }

  const triangles = triangulate(points);

  for (const tri of triangles) {
    const cx = (tri[0].x + tri[1].x + tri[2].x) / 3;
    const cy = (tri[0].y + tri[1].y + tri[2].y) / 3;

    if (cx < -50 || cx > W + 50 || cy < -50 || cy > H + 50) continue;

    let r = 0, g = 0, b = 0, a = 0;
    let matched = 0;
    for (const v of tri) {
      const idx = pointIndex.get(v);
      if (idx !== undefined && pointColors[idx]) {
        const c = pointColors[idx];
        r += c[0]; g += c[1]; b += c[2]; a += c[3];
        matched++;
      }
    }
    if (matched > 0) {
      r = (r / matched) | 0;
      g = (g / matched) | 0;
      b = (b / matched) | 0;
      a = a / matched;
    } else {
      r = 15; g = 20; b = 40; a = 0.5;
    }

    ctx.beginPath();
    ctx.moveTo(tri[0].x, tri[0].y);
    ctx.lineTo(tri[1].x, tri[1].y);
    ctx.lineTo(tri[2].x, tri[2].y);
    ctx.closePath();

    ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`;
    ctx.fill();

    const distToMouse = Math.hypot(cx - smoothMouse.x, cy - smoothMouse.y);
    const proximity = Math.max(0, 1 - distToMouse / (INFLUENCE_RADIUS * 2));
    const sa = 0.03 + proximity * 0.15;
    ctx.strokeStyle = `rgba(220, 180, 255, ${sa})`;
    ctx.lineWidth = 0.5;
    ctx.stroke();
  }

  if (smoothMouse.x > 0) {
    const glow = ctx.createRadialGradient(
      smoothMouse.x, smoothMouse.y, 0,
      smoothMouse.x, smoothMouse.y, INFLUENCE_RADIUS * 1.2
    );
    glow.addColorStop(0, 'rgba(170, 100, 220, 0.04)');
    glow.addColorStop(0.5, 'rgba(140, 70, 180, 0.015)');
    glow.addColorStop(1, 'rgba(0, 0, 0, 0)');
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, W, H);
  }
}

function loop() {
  update();
  draw();
  animFrame = requestAnimationFrame(loop);
}

// --- Events: all relative to the canvas element ---

// Convert page-level mouse coords to canvas-local coords
function getCanvasCoords(e) {
  const rect = canvas.getBoundingClientRect();
  return {
    x: e.clientX - rect.left,
    y: e.clientY - rect.top
  };
}

// Use ResizeObserver to react to container size changes
const ro = new ResizeObserver(() => resize());
ro.observe(canvas.parentElement);

// Mouse events on the canvas itself
canvas.addEventListener('mousemove', (e) => {
  const pos = getCanvasCoords(e);
  mouse.x = pos.x;
  mouse.y = pos.y;
  mouseActivity = 1;
});

canvas.addEventListener('mouseleave', () => {
  mouse.x = -9999;
  mouse.y = -9999;
});

// Touch events on the canvas
canvas.addEventListener('touchmove', (e) => {
  const rect = canvas.getBoundingClientRect();
  mouse.x = e.touches[0].clientX - rect.left;
  mouse.y = e.touches[0].clientY - rect.top;
  mouseActivity = 1;
}, { passive: false });

canvas.addEventListener('touchend', () => {
  mouse.x = -9999;
  mouse.y = -9999;
});

resize();
loop();